<template>
  <v-card
    class="pa-4"
    color="primary"
    dark
    :to="to"
    :tag="to ? 'a' : 'div'"
    :hover="!!to"
    min-height="244"
    tile
    outlined
  >
    <div style="display:flex; flex-direction:column">
      <div class="d-flex justify-center mt-4 mb-4">
        <PractitionerAvatar
          :id="(practitioner.profilePicture || {}).id"
          size="70"
        ></PractitionerAvatar>
      </div>
      <p class="text-center font-weight-bold title mb-1 mt-2">
        {{ practitioner.name || "--" }}
      </p>
    </div>
  </v-card>
</template>

<script>
import PractitionerAvatar from "./PractitionerAvatar";
export default {
  props: ["practitioner", "to"],
  components: { PractitionerAvatar }
};
</script>

<style></style>
